export default __webpack_public_path__ + "static/media/loss-anylisis.79766332.svg";